import * as dayjs from 'dayjs';

export function parseDate(date: Date) {
  const format = 'YYYY-MM-DD';
  return (dayjs as any)(date).format(format);
}

export function parseTime(date: Date) {
  const format = 'YYYY-MM-DD HH:mm:ss';
  return (dayjs as any)(date).format(format);
}

export function onlyTime(date: Date) {
  const format = 'HH:mm';
  return (dayjs as any)(date).format(format);
}

export function getDuration(a: any, b: any) {
  let t1 = Date.parse(new Date(a.toString().replace(/-/g, '/')) as any);
  let t2 = Date.parse(new Date(b.toString().replace(/-/g, '/')) as any);
  return (dayjs as any)(t1 - t2).format('HH时mm分');
  // console.log(
  //   '((dayjs as any).duration as any)((x as any).diff(y)): ',
  //   ((dayjs as any).duration as any)((x.diff as any)(y))
  // );
  // console.log(
  //   '((dayjs as any).duration as any)((x as any).diff(y)): ',
  //   ((dayjs as any).duration as any)((x.diff as any)(y)).as('hours')
  // );
  // return ((dayjs as any).duration as any)(((x as any).diff as any)(y));
}
